// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2HrFr","row":"Node_row__3EqNT","label":"Node_label__1FZVv","footer":"Node_footer__10ppP"};